import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import enTranslations from './locales/en/translation.json';
import esTranslations from './locales/es/translation.json';
import ruTranslations from './locales/ru/translation.json'; // As requested in project requirements

// Create locales directory structure
const resources = {
  en: {
    translation: enTranslations
  },
  es: {
    translation: esTranslations
  },
  ru: {
    translation: ruTranslations
  }
};

i18n
  .use(LanguageDetector) // Detects user's language
  .use(initReactI18next) // Passes i18n down to react-i18next
  .init({
    resources,
    lng: 'es', // Default language
    fallbackLng: 'es', // Fallback language
    interpolation: {
      escapeValue: false // React already safes from xss
    },
    detection: {
      order: ['queryString', 'cookie', 'localStorage', 'sessionStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage', 'sessionStorage'],
    }
  });

export default i18n;